"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPortInUseFilePath = void 0;
const os_1 = require("os");
const API_PROXY_PORT_IN_USE_FILE_PATH_WIN = '\\AppData\\Roaming\\Refinitiv\\Data API Proxy\\.portInUse';
const API_PROXY_PORT_IN_USE_FILE_PATH_MAC = '/Library/Application Support/Data API Proxy/.portInUse';
const API_PROXY_PORT_IN_USE_FILE_PATH_LINUX = '/.config/Refinitiv/Data API Proxy/.portInUse';
function getPortInUseFilePath() {
    const platform = process.platform;
    const homeDir = (0, os_1.userInfo)().homedir;
    let path = '';
    switch (platform) {
        case 'darwin':
            path = `${homeDir}${API_PROXY_PORT_IN_USE_FILE_PATH_MAC}`;
            break;
        case 'win32':
            path = `${homeDir}${API_PROXY_PORT_IN_USE_FILE_PATH_WIN}`;
            break;
        case 'linux':
            path = `${homeDir}${API_PROXY_PORT_IN_USE_FILE_PATH_LINUX}`;
    }
    return path;
}
exports.getPortInUseFilePath = getPortInUseFilePath;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LXBvcnQtaW4tdXNlLWZpbGUtcGF0aC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlsL2dldC1wb3J0LWluLXVzZS1maWxlLXBhdGgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsMkJBQThCO0FBRTlCLE1BQU0sbUNBQW1DLEdBQUcsMkRBQTJELENBQUM7QUFDeEcsTUFBTSxtQ0FBbUMsR0FBRyx3REFBd0QsQ0FBQztBQUNyRyxNQUFNLHFDQUFxQyxHQUFHLDhDQUE4QyxDQUFDO0FBRTdGLFNBQWdCLG9CQUFvQjtJQUNoQyxNQUFNLFFBQVEsR0FBRyxPQUFPLENBQUMsUUFBUSxDQUFDO0lBQ2xDLE1BQU0sT0FBTyxHQUFHLElBQUEsYUFBUSxHQUFFLENBQUMsT0FBTyxDQUFDO0lBRW5DLElBQUksSUFBSSxHQUFHLEVBQUUsQ0FBQztJQUVkLFFBQVEsUUFBUSxFQUFFLENBQUM7UUFDZixLQUFLLFFBQVE7WUFDVCxJQUFJLEdBQUcsR0FBRyxPQUFPLEdBQUcsbUNBQW1DLEVBQUUsQ0FBQztZQUMxRCxNQUFNO1FBQ1YsS0FBSyxPQUFPO1lBQ1IsSUFBSSxHQUFHLEdBQUcsT0FBTyxHQUFHLG1DQUFtQyxFQUFFLENBQUM7WUFDMUQsTUFBTTtRQUNWLEtBQUssT0FBTztZQUNSLElBQUksR0FBRyxHQUFHLE9BQU8sR0FBRyxxQ0FBcUMsRUFBRSxDQUFDO0lBQ3BFLENBQUM7SUFFRCxPQUFPLElBQUksQ0FBQztBQUNoQixDQUFDO0FBbEJELG9EQWtCQyJ9